/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const com = $root.com = (() => {

    /**
     * Namespace com.
     * @exports com
     * @namespace
     */
    const com = {};

    com.tecdo = (function() {

        /**
         * Namespace tecdo.
         * @memberof com
         * @namespace
         */
        const tecdo = {};

        tecdo.sdk = (function() {

            /**
             * Namespace sdk.
             * @memberof com.tecdo
             * @namespace
             */
            const sdk = {};

            sdk.common = (function() {

                /**
                 * Namespace common.
                 * @memberof com.tecdo.sdk
                 * @namespace
                 */
                const common = {};

                common.SdkEventRequest = (function() {

                    /**
                     * Properties of a SdkEventRequest.
                     * @memberof com.tecdo.sdk.common
                     * @interface ISdkEventRequest
                     * @property {string|null} [platform] SdkEventRequest platform
                     * @property {com.tecdo.sdk.android.IAndroidEventData|null} [androidData] SdkEventRequest androidData
                     * @property {com.tecdo.sdk.web.IWebEventData|null} [webData] SdkEventRequest webData
                     * @property {com.tecdo.sdk.ios.IIosEventData|null} [iosData] SdkEventRequest iosData
                     * @property {string|null} [dataVersion] SdkEventRequest dataVersion
                     * @property {string|null} [deviceId] SdkEventRequest deviceId
                     */

                    /**
                     * Constructs a new SdkEventRequest.
                     * @memberof com.tecdo.sdk.common
                     * @classdesc Represents a SdkEventRequest.
                     * @implements ISdkEventRequest
                     * @constructor
                     * @param {com.tecdo.sdk.common.ISdkEventRequest=} [p] Properties to set
                     */
                    function SdkEventRequest(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * SdkEventRequest platform.
                     * @member {string} platform
                     * @memberof com.tecdo.sdk.common.SdkEventRequest
                     * @instance
                     */
                    SdkEventRequest.prototype.platform = "";

                    /**
                     * SdkEventRequest androidData.
                     * @member {com.tecdo.sdk.android.IAndroidEventData|null|undefined} androidData
                     * @memberof com.tecdo.sdk.common.SdkEventRequest
                     * @instance
                     */
                    SdkEventRequest.prototype.androidData = null;

                    /**
                     * SdkEventRequest webData.
                     * @member {com.tecdo.sdk.web.IWebEventData|null|undefined} webData
                     * @memberof com.tecdo.sdk.common.SdkEventRequest
                     * @instance
                     */
                    SdkEventRequest.prototype.webData = null;

                    /**
                     * SdkEventRequest iosData.
                     * @member {com.tecdo.sdk.ios.IIosEventData|null|undefined} iosData
                     * @memberof com.tecdo.sdk.common.SdkEventRequest
                     * @instance
                     */
                    SdkEventRequest.prototype.iosData = null;

                    /**
                     * SdkEventRequest dataVersion.
                     * @member {string} dataVersion
                     * @memberof com.tecdo.sdk.common.SdkEventRequest
                     * @instance
                     */
                    SdkEventRequest.prototype.dataVersion = "";

                    /**
                     * SdkEventRequest deviceId.
                     * @member {string} deviceId
                     * @memberof com.tecdo.sdk.common.SdkEventRequest
                     * @instance
                     */
                    SdkEventRequest.prototype.deviceId = "";

                    /**
                     * Creates a new SdkEventRequest instance using the specified properties.
                     * @function create
                     * @memberof com.tecdo.sdk.common.SdkEventRequest
                     * @static
                     * @param {com.tecdo.sdk.common.ISdkEventRequest=} [properties] Properties to set
                     * @returns {com.tecdo.sdk.common.SdkEventRequest} SdkEventRequest instance
                     */
                    SdkEventRequest.create = function create(properties) {
                        return new SdkEventRequest(properties);
                    };

                    /**
                     * Encodes the specified SdkEventRequest message. Does not implicitly {@link com.tecdo.sdk.common.SdkEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.tecdo.sdk.common.SdkEventRequest
                     * @static
                     * @param {com.tecdo.sdk.common.ISdkEventRequest} m SdkEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SdkEventRequest.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.platform != null && Object.hasOwnProperty.call(m, "platform"))
                            w.uint32(10).string(m.platform);
                        if (m.androidData != null && Object.hasOwnProperty.call(m, "androidData"))
                            $root.com.tecdo.sdk.android.AndroidEventData.encode(m.androidData, w.uint32(18).fork()).ldelim();
                        if (m.webData != null && Object.hasOwnProperty.call(m, "webData"))
                            $root.com.tecdo.sdk.web.WebEventData.encode(m.webData, w.uint32(26).fork()).ldelim();
                        if (m.iosData != null && Object.hasOwnProperty.call(m, "iosData"))
                            $root.com.tecdo.sdk.ios.IosEventData.encode(m.iosData, w.uint32(34).fork()).ldelim();
                        if (m.dataVersion != null && Object.hasOwnProperty.call(m, "dataVersion"))
                            w.uint32(42).string(m.dataVersion);
                        if (m.deviceId != null && Object.hasOwnProperty.call(m, "deviceId"))
                            w.uint32(50).string(m.deviceId);
                        return w;
                    };

                    /**
                     * Gets the default type url for SdkEventRequest
                     * @function getTypeUrl
                     * @memberof com.tecdo.sdk.common.SdkEventRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SdkEventRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.tecdo.sdk.common.SdkEventRequest";
                    };

                    return SdkEventRequest;
                })();

                return common;
            })();

            sdk.web = (function() {

                /**
                 * Namespace web.
                 * @memberof com.tecdo.sdk
                 * @namespace
                 */
                const web = {};

                web.WebEventData = (function() {

                    /**
                     * Properties of a WebEventData.
                     * @memberof com.tecdo.sdk.web
                     * @interface IWebEventData
                     * @property {com.ssp.sdk.event.IBaseEventData|null} [baseData] WebEventData baseData
                     * @property {com.tecdo.sdk.web.IDeviceInfo|null} [deviceInfo] WebEventData deviceInfo
                     */

                    /**
                     * Constructs a new WebEventData.
                     * @memberof com.tecdo.sdk.web
                     * @classdesc Represents a WebEventData.
                     * @implements IWebEventData
                     * @constructor
                     * @param {com.tecdo.sdk.web.IWebEventData=} [p] Properties to set
                     */
                    function WebEventData(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * WebEventData baseData.
                     * @member {com.ssp.sdk.event.IBaseEventData|null|undefined} baseData
                     * @memberof com.tecdo.sdk.web.WebEventData
                     * @instance
                     */
                    WebEventData.prototype.baseData = null;

                    /**
                     * WebEventData deviceInfo.
                     * @member {com.tecdo.sdk.web.IDeviceInfo|null|undefined} deviceInfo
                     * @memberof com.tecdo.sdk.web.WebEventData
                     * @instance
                     */
                    WebEventData.prototype.deviceInfo = null;

                    /**
                     * Creates a new WebEventData instance using the specified properties.
                     * @function create
                     * @memberof com.tecdo.sdk.web.WebEventData
                     * @static
                     * @param {com.tecdo.sdk.web.IWebEventData=} [properties] Properties to set
                     * @returns {com.tecdo.sdk.web.WebEventData} WebEventData instance
                     */
                    WebEventData.create = function create(properties) {
                        return new WebEventData(properties);
                    };

                    /**
                     * Encodes the specified WebEventData message. Does not implicitly {@link com.tecdo.sdk.web.WebEventData.verify|verify} messages.
                     * @function encode
                     * @memberof com.tecdo.sdk.web.WebEventData
                     * @static
                     * @param {com.tecdo.sdk.web.IWebEventData} m WebEventData message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WebEventData.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.baseData != null && Object.hasOwnProperty.call(m, "baseData"))
                            $root.com.ssp.sdk.event.BaseEventData.encode(m.baseData, w.uint32(10).fork()).ldelim();
                        if (m.deviceInfo != null && Object.hasOwnProperty.call(m, "deviceInfo"))
                            $root.com.tecdo.sdk.web.DeviceInfo.encode(m.deviceInfo, w.uint32(18).fork()).ldelim();
                        return w;
                    };

                    /**
                     * Gets the default type url for WebEventData
                     * @function getTypeUrl
                     * @memberof com.tecdo.sdk.web.WebEventData
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    WebEventData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.tecdo.sdk.web.WebEventData";
                    };

                    return WebEventData;
                })();

                web.DeviceInfo = (function() {

                    /**
                     * Properties of a DeviceInfo.
                     * @memberof com.tecdo.sdk.web
                     * @interface IDeviceInfo
                     * @property {com.tecdo.sdk.web.IDevice|null} [a] DeviceInfo a
                     * @property {com.tecdo.sdk.web.ISystem|null} [b] DeviceInfo b
                     * @property {com.tecdo.sdk.web.INetwork|null} [c] DeviceInfo c
                     * @property {com.tecdo.sdk.web.IUser|null} [d] DeviceInfo d
                     * @property {com.tecdo.sdk.web.IApplication|null} [e] DeviceInfo e
                     * @property {com.tecdo.sdk.web.ILocation|null} [f] DeviceInfo f
                     * @property {com.tecdo.sdk.web.ISecurity|null} [g] DeviceInfo g
                     */

                    /**
                     * Constructs a new DeviceInfo.
                     * @memberof com.tecdo.sdk.web
                     * @classdesc Represents a DeviceInfo.
                     * @implements IDeviceInfo
                     * @constructor
                     * @param {com.tecdo.sdk.web.IDeviceInfo=} [p] Properties to set
                     */
                    function DeviceInfo(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * DeviceInfo a.
                     * @member {com.tecdo.sdk.web.IDevice|null|undefined} a
                     * @memberof com.tecdo.sdk.web.DeviceInfo
                     * @instance
                     */
                    DeviceInfo.prototype.a = null;

                    /**
                     * DeviceInfo b.
                     * @member {com.tecdo.sdk.web.ISystem|null|undefined} b
                     * @memberof com.tecdo.sdk.web.DeviceInfo
                     * @instance
                     */
                    DeviceInfo.prototype.b = null;

                    /**
                     * DeviceInfo c.
                     * @member {com.tecdo.sdk.web.INetwork|null|undefined} c
                     * @memberof com.tecdo.sdk.web.DeviceInfo
                     * @instance
                     */
                    DeviceInfo.prototype.c = null;

                    /**
                     * DeviceInfo d.
                     * @member {com.tecdo.sdk.web.IUser|null|undefined} d
                     * @memberof com.tecdo.sdk.web.DeviceInfo
                     * @instance
                     */
                    DeviceInfo.prototype.d = null;

                    /**
                     * DeviceInfo e.
                     * @member {com.tecdo.sdk.web.IApplication|null|undefined} e
                     * @memberof com.tecdo.sdk.web.DeviceInfo
                     * @instance
                     */
                    DeviceInfo.prototype.e = null;

                    /**
                     * DeviceInfo f.
                     * @member {com.tecdo.sdk.web.ILocation|null|undefined} f
                     * @memberof com.tecdo.sdk.web.DeviceInfo
                     * @instance
                     */
                    DeviceInfo.prototype.f = null;

                    /**
                     * DeviceInfo g.
                     * @member {com.tecdo.sdk.web.ISecurity|null|undefined} g
                     * @memberof com.tecdo.sdk.web.DeviceInfo
                     * @instance
                     */
                    DeviceInfo.prototype.g = null;

                    /**
                     * Creates a new DeviceInfo instance using the specified properties.
                     * @function create
                     * @memberof com.tecdo.sdk.web.DeviceInfo
                     * @static
                     * @param {com.tecdo.sdk.web.IDeviceInfo=} [properties] Properties to set
                     * @returns {com.tecdo.sdk.web.DeviceInfo} DeviceInfo instance
                     */
                    DeviceInfo.create = function create(properties) {
                        return new DeviceInfo(properties);
                    };

                    /**
                     * Encodes the specified DeviceInfo message. Does not implicitly {@link com.tecdo.sdk.web.DeviceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof com.tecdo.sdk.web.DeviceInfo
                     * @static
                     * @param {com.tecdo.sdk.web.IDeviceInfo} m DeviceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeviceInfo.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.a != null && Object.hasOwnProperty.call(m, "a"))
                            $root.com.tecdo.sdk.web.Device.encode(m.a, w.uint32(10).fork()).ldelim();
                        if (m.b != null && Object.hasOwnProperty.call(m, "b"))
                            $root.com.tecdo.sdk.web.System.encode(m.b, w.uint32(18).fork()).ldelim();
                        if (m.c != null && Object.hasOwnProperty.call(m, "c"))
                            $root.com.tecdo.sdk.web.Network.encode(m.c, w.uint32(26).fork()).ldelim();
                        if (m.d != null && Object.hasOwnProperty.call(m, "d"))
                            $root.com.tecdo.sdk.web.User.encode(m.d, w.uint32(34).fork()).ldelim();
                        if (m.e != null && Object.hasOwnProperty.call(m, "e"))
                            $root.com.tecdo.sdk.web.Application.encode(m.e, w.uint32(42).fork()).ldelim();
                        if (m.f != null && Object.hasOwnProperty.call(m, "f"))
                            $root.com.tecdo.sdk.web.Location.encode(m.f, w.uint32(50).fork()).ldelim();
                        if (m.g != null && Object.hasOwnProperty.call(m, "g"))
                            $root.com.tecdo.sdk.web.Security.encode(m.g, w.uint32(58).fork()).ldelim();
                        return w;
                    };

                    /**
                     * Gets the default type url for DeviceInfo
                     * @function getTypeUrl
                     * @memberof com.tecdo.sdk.web.DeviceInfo
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    DeviceInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.tecdo.sdk.web.DeviceInfo";
                    };

                    return DeviceInfo;
                })();

                web.Device = (function() {

                    /**
                     * Properties of a Device.
                     * @memberof com.tecdo.sdk.web
                     * @interface IDevice
                     * @property {string|null} [aa] Device aa
                     * @property {string|null} [ab] Device ab
                     * @property {string|null} [ac] Device ac
                     * @property {number|null} [ad] Device ad
                     * @property {number|null} [ae] Device ae
                     * @property {number|null} [af] Device af
                     * @property {number|null} [ag] Device ag
                     * @property {number|null} [ah] Device ah
                     * @property {string|null} [ai] Device ai
                     * @property {string|null} [aj] Device aj
                     * @property {number|null} [ak] Device ak
                     * @property {number|null} [al] Device al
                     * @property {number|null} [am] Device am
                     * @property {number|null} [an] Device an
                     */

                    /**
                     * Constructs a new Device.
                     * @memberof com.tecdo.sdk.web
                     * @classdesc Represents a Device.
                     * @implements IDevice
                     * @constructor
                     * @param {com.tecdo.sdk.web.IDevice=} [p] Properties to set
                     */
                    function Device(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * Device aa.
                     * @member {string} aa
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.aa = "";

                    /**
                     * Device ab.
                     * @member {string} ab
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.ab = "";

                    /**
                     * Device ac.
                     * @member {string} ac
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.ac = "";

                    /**
                     * Device ad.
                     * @member {number} ad
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.ad = 0;

                    /**
                     * Device ae.
                     * @member {number} ae
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.ae = 0;

                    /**
                     * Device af.
                     * @member {number} af
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.af = 0;

                    /**
                     * Device ag.
                     * @member {number} ag
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.ag = 0;

                    /**
                     * Device ah.
                     * @member {number} ah
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.ah = 0;

                    /**
                     * Device ai.
                     * @member {string} ai
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.ai = "";

                    /**
                     * Device aj.
                     * @member {string} aj
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.aj = "";

                    /**
                     * Device ak.
                     * @member {number} ak
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.ak = 0;

                    /**
                     * Device al.
                     * @member {number} al
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.al = 0;

                    /**
                     * Device am.
                     * @member {number} am
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.am = 0;

                    /**
                     * Device an.
                     * @member {number} an
                     * @memberof com.tecdo.sdk.web.Device
                     * @instance
                     */
                    Device.prototype.an = 0;

                    /**
                     * Creates a new Device instance using the specified properties.
                     * @function create
                     * @memberof com.tecdo.sdk.web.Device
                     * @static
                     * @param {com.tecdo.sdk.web.IDevice=} [properties] Properties to set
                     * @returns {com.tecdo.sdk.web.Device} Device instance
                     */
                    Device.create = function create(properties) {
                        return new Device(properties);
                    };

                    /**
                     * Encodes the specified Device message. Does not implicitly {@link com.tecdo.sdk.web.Device.verify|verify} messages.
                     * @function encode
                     * @memberof com.tecdo.sdk.web.Device
                     * @static
                     * @param {com.tecdo.sdk.web.IDevice} m Device message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Device.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.aa != null && Object.hasOwnProperty.call(m, "aa"))
                            w.uint32(10).string(m.aa);
                        if (m.ab != null && Object.hasOwnProperty.call(m, "ab"))
                            w.uint32(18).string(m.ab);
                        if (m.ac != null && Object.hasOwnProperty.call(m, "ac"))
                            w.uint32(26).string(m.ac);
                        if (m.ad != null && Object.hasOwnProperty.call(m, "ad"))
                            w.uint32(32).int32(m.ad);
                        if (m.ae != null && Object.hasOwnProperty.call(m, "ae"))
                            w.uint32(40).int32(m.ae);
                        if (m.af != null && Object.hasOwnProperty.call(m, "af"))
                            w.uint32(48).int32(m.af);
                        if (m.ag != null && Object.hasOwnProperty.call(m, "ag"))
                            w.uint32(56).int32(m.ag);
                        if (m.ah != null && Object.hasOwnProperty.call(m, "ah"))
                            w.uint32(69).float(m.ah);
                        if (m.ai != null && Object.hasOwnProperty.call(m, "ai"))
                            w.uint32(74).string(m.ai);
                        if (m.aj != null && Object.hasOwnProperty.call(m, "aj"))
                            w.uint32(82).string(m.aj);
                        if (m.ak != null && Object.hasOwnProperty.call(m, "ak"))
                            w.uint32(88).int32(m.ak);
                        if (m.al != null && Object.hasOwnProperty.call(m, "al"))
                            w.uint32(96).int32(m.al);
                        if (m.am != null && Object.hasOwnProperty.call(m, "am"))
                            w.uint32(104).int32(m.am);
                        if (m.an != null && Object.hasOwnProperty.call(m, "an"))
                            w.uint32(112).int32(m.an);
                        return w;
                    };

                    /**
                     * Gets the default type url for Device
                     * @function getTypeUrl
                     * @memberof com.tecdo.sdk.web.Device
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Device.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.tecdo.sdk.web.Device";
                    };

                    return Device;
                })();

                web.System = (function() {

                    /**
                     * Properties of a System.
                     * @memberof com.tecdo.sdk.web
                     * @interface ISystem
                     * @property {string|null} [ba] System ba
                     * @property {string|null} [bb] System bb
                     * @property {boolean|null} [bc] System bc
                     * @property {string|null} [bd] System bd
                     * @property {boolean|null} [be] System be
                     * @property {string|null} [bf] System bf
                     * @property {string|null} [bg] System bg
                     * @property {string|null} [bh] System bh
                     * @property {string|null} [bi] System bi
                     * @property {string|null} [bj] System bj
                     * @property {boolean|null} [bk] System bk
                     */

                    /**
                     * Constructs a new System.
                     * @memberof com.tecdo.sdk.web
                     * @classdesc Represents a System.
                     * @implements ISystem
                     * @constructor
                     * @param {com.tecdo.sdk.web.ISystem=} [p] Properties to set
                     */
                    function System(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * System ba.
                     * @member {string} ba
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.ba = "";

                    /**
                     * System bb.
                     * @member {string} bb
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.bb = "";

                    /**
                     * System bc.
                     * @member {boolean} bc
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.bc = false;

                    /**
                     * System bd.
                     * @member {string} bd
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.bd = "";

                    /**
                     * System be.
                     * @member {boolean} be
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.be = false;

                    /**
                     * System bf.
                     * @member {string} bf
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.bf = "";

                    /**
                     * System bg.
                     * @member {string} bg
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.bg = "";

                    /**
                     * System bh.
                     * @member {string} bh
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.bh = "";

                    /**
                     * System bi.
                     * @member {string} bi
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.bi = "";

                    /**
                     * System bj.
                     * @member {string} bj
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.bj = "";

                    /**
                     * System bk.
                     * @member {boolean} bk
                     * @memberof com.tecdo.sdk.web.System
                     * @instance
                     */
                    System.prototype.bk = false;

                    /**
                     * Creates a new System instance using the specified properties.
                     * @function create
                     * @memberof com.tecdo.sdk.web.System
                     * @static
                     * @param {com.tecdo.sdk.web.ISystem=} [properties] Properties to set
                     * @returns {com.tecdo.sdk.web.System} System instance
                     */
                    System.create = function create(properties) {
                        return new System(properties);
                    };

                    /**
                     * Encodes the specified System message. Does not implicitly {@link com.tecdo.sdk.web.System.verify|verify} messages.
                     * @function encode
                     * @memberof com.tecdo.sdk.web.System
                     * @static
                     * @param {com.tecdo.sdk.web.ISystem} m System message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    System.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.ba != null && Object.hasOwnProperty.call(m, "ba"))
                            w.uint32(10).string(m.ba);
                        if (m.bb != null && Object.hasOwnProperty.call(m, "bb"))
                            w.uint32(18).string(m.bb);
                        if (m.bc != null && Object.hasOwnProperty.call(m, "bc"))
                            w.uint32(24).bool(m.bc);
                        if (m.bd != null && Object.hasOwnProperty.call(m, "bd"))
                            w.uint32(34).string(m.bd);
                        if (m.be != null && Object.hasOwnProperty.call(m, "be"))
                            w.uint32(40).bool(m.be);
                        if (m.bf != null && Object.hasOwnProperty.call(m, "bf"))
                            w.uint32(50).string(m.bf);
                        if (m.bg != null && Object.hasOwnProperty.call(m, "bg"))
                            w.uint32(58).string(m.bg);
                        if (m.bh != null && Object.hasOwnProperty.call(m, "bh"))
                            w.uint32(66).string(m.bh);
                        if (m.bi != null && Object.hasOwnProperty.call(m, "bi"))
                            w.uint32(74).string(m.bi);
                        if (m.bj != null && Object.hasOwnProperty.call(m, "bj"))
                            w.uint32(82).string(m.bj);
                        if (m.bk != null && Object.hasOwnProperty.call(m, "bk"))
                            w.uint32(88).bool(m.bk);
                        return w;
                    };

                    /**
                     * Gets the default type url for System
                     * @function getTypeUrl
                     * @memberof com.tecdo.sdk.web.System
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    System.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.tecdo.sdk.web.System";
                    };

                    return System;
                })();

                web.Network = (function() {

                    /**
                     * Properties of a Network.
                     * @memberof com.tecdo.sdk.web
                     * @interface INetwork
                     * @property {string|null} [ca] Network ca
                     * @property {string|null} [cb] Network cb
                     * @property {string|null} [cc] Network cc
                     * @property {string|null} [cd] Network cd
                     * @property {boolean|null} [ce] Network ce
                     * @property {string|null} [cf] Network cf
                     */

                    /**
                     * Constructs a new Network.
                     * @memberof com.tecdo.sdk.web
                     * @classdesc Represents a Network.
                     * @implements INetwork
                     * @constructor
                     * @param {com.tecdo.sdk.web.INetwork=} [p] Properties to set
                     */
                    function Network(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * Network ca.
                     * @member {string} ca
                     * @memberof com.tecdo.sdk.web.Network
                     * @instance
                     */
                    Network.prototype.ca = "";

                    /**
                     * Network cb.
                     * @member {string} cb
                     * @memberof com.tecdo.sdk.web.Network
                     * @instance
                     */
                    Network.prototype.cb = "";

                    /**
                     * Network cc.
                     * @member {string} cc
                     * @memberof com.tecdo.sdk.web.Network
                     * @instance
                     */
                    Network.prototype.cc = "";

                    /**
                     * Network cd.
                     * @member {string} cd
                     * @memberof com.tecdo.sdk.web.Network
                     * @instance
                     */
                    Network.prototype.cd = "";

                    /**
                     * Network ce.
                     * @member {boolean} ce
                     * @memberof com.tecdo.sdk.web.Network
                     * @instance
                     */
                    Network.prototype.ce = false;

                    /**
                     * Network cf.
                     * @member {string} cf
                     * @memberof com.tecdo.sdk.web.Network
                     * @instance
                     */
                    Network.prototype.cf = "";

                    /**
                     * Creates a new Network instance using the specified properties.
                     * @function create
                     * @memberof com.tecdo.sdk.web.Network
                     * @static
                     * @param {com.tecdo.sdk.web.INetwork=} [properties] Properties to set
                     * @returns {com.tecdo.sdk.web.Network} Network instance
                     */
                    Network.create = function create(properties) {
                        return new Network(properties);
                    };

                    /**
                     * Encodes the specified Network message. Does not implicitly {@link com.tecdo.sdk.web.Network.verify|verify} messages.
                     * @function encode
                     * @memberof com.tecdo.sdk.web.Network
                     * @static
                     * @param {com.tecdo.sdk.web.INetwork} m Network message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Network.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.ca != null && Object.hasOwnProperty.call(m, "ca"))
                            w.uint32(10).string(m.ca);
                        if (m.cb != null && Object.hasOwnProperty.call(m, "cb"))
                            w.uint32(18).string(m.cb);
                        if (m.cc != null && Object.hasOwnProperty.call(m, "cc"))
                            w.uint32(26).string(m.cc);
                        if (m.cd != null && Object.hasOwnProperty.call(m, "cd"))
                            w.uint32(34).string(m.cd);
                        if (m.ce != null && Object.hasOwnProperty.call(m, "ce"))
                            w.uint32(40).bool(m.ce);
                        if (m.cf != null && Object.hasOwnProperty.call(m, "cf"))
                            w.uint32(50).string(m.cf);
                        return w;
                    };

                    /**
                     * Gets the default type url for Network
                     * @function getTypeUrl
                     * @memberof com.tecdo.sdk.web.Network
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Network.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.tecdo.sdk.web.Network";
                    };

                    return Network;
                })();

                web.User = (function() {

                    /**
                     * Properties of a User.
                     * @memberof com.tecdo.sdk.web
                     * @interface IUser
                     * @property {string|null} [da] User da
                     * @property {string|null} [db] User db
                     * @property {boolean|null} [dc] User dc
                     * @property {boolean|null} [dd] User dd
                     * @property {boolean|null} [de] User de
                     */

                    /**
                     * Constructs a new User.
                     * @memberof com.tecdo.sdk.web
                     * @classdesc Represents a User.
                     * @implements IUser
                     * @constructor
                     * @param {com.tecdo.sdk.web.IUser=} [p] Properties to set
                     */
                    function User(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * User da.
                     * @member {string} da
                     * @memberof com.tecdo.sdk.web.User
                     * @instance
                     */
                    User.prototype.da = "";

                    /**
                     * User db.
                     * @member {string} db
                     * @memberof com.tecdo.sdk.web.User
                     * @instance
                     */
                    User.prototype.db = "";

                    /**
                     * User dc.
                     * @member {boolean} dc
                     * @memberof com.tecdo.sdk.web.User
                     * @instance
                     */
                    User.prototype.dc = false;

                    /**
                     * User dd.
                     * @member {boolean} dd
                     * @memberof com.tecdo.sdk.web.User
                     * @instance
                     */
                    User.prototype.dd = false;

                    /**
                     * User de.
                     * @member {boolean} de
                     * @memberof com.tecdo.sdk.web.User
                     * @instance
                     */
                    User.prototype.de = false;

                    /**
                     * Creates a new User instance using the specified properties.
                     * @function create
                     * @memberof com.tecdo.sdk.web.User
                     * @static
                     * @param {com.tecdo.sdk.web.IUser=} [properties] Properties to set
                     * @returns {com.tecdo.sdk.web.User} User instance
                     */
                    User.create = function create(properties) {
                        return new User(properties);
                    };

                    /**
                     * Encodes the specified User message. Does not implicitly {@link com.tecdo.sdk.web.User.verify|verify} messages.
                     * @function encode
                     * @memberof com.tecdo.sdk.web.User
                     * @static
                     * @param {com.tecdo.sdk.web.IUser} m User message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    User.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.da != null && Object.hasOwnProperty.call(m, "da"))
                            w.uint32(10).string(m.da);
                        if (m.db != null && Object.hasOwnProperty.call(m, "db"))
                            w.uint32(18).string(m.db);
                        if (m.dc != null && Object.hasOwnProperty.call(m, "dc"))
                            w.uint32(24).bool(m.dc);
                        if (m.dd != null && Object.hasOwnProperty.call(m, "dd"))
                            w.uint32(32).bool(m.dd);
                        if (m.de != null && Object.hasOwnProperty.call(m, "de"))
                            w.uint32(40).bool(m.de);
                        return w;
                    };

                    /**
                     * Gets the default type url for User
                     * @function getTypeUrl
                     * @memberof com.tecdo.sdk.web.User
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    User.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.tecdo.sdk.web.User";
                    };

                    return User;
                })();

                web.Application = (function() {

                    /**
                     * Properties of an Application.
                     * @memberof com.tecdo.sdk.web
                     * @interface IApplication
                     * @property {string|null} [ea] Application ea
                     * @property {string|null} [eb] Application eb
                     * @property {string|null} [ec] Application ec
                     * @property {string|null} [ed] Application ed
                     * @property {string|null} [ee] Application ee
                     * @property {string|null} [ef] Application ef
                     * @property {string|null} [eg] Application eg
                     */

                    /**
                     * Constructs a new Application.
                     * @memberof com.tecdo.sdk.web
                     * @classdesc Represents an Application.
                     * @implements IApplication
                     * @constructor
                     * @param {com.tecdo.sdk.web.IApplication=} [p] Properties to set
                     */
                    function Application(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * Application ea.
                     * @member {string} ea
                     * @memberof com.tecdo.sdk.web.Application
                     * @instance
                     */
                    Application.prototype.ea = "";

                    /**
                     * Application eb.
                     * @member {string} eb
                     * @memberof com.tecdo.sdk.web.Application
                     * @instance
                     */
                    Application.prototype.eb = "";

                    /**
                     * Application ec.
                     * @member {string} ec
                     * @memberof com.tecdo.sdk.web.Application
                     * @instance
                     */
                    Application.prototype.ec = "";

                    /**
                     * Application ed.
                     * @member {string} ed
                     * @memberof com.tecdo.sdk.web.Application
                     * @instance
                     */
                    Application.prototype.ed = "";

                    /**
                     * Application ee.
                     * @member {string} ee
                     * @memberof com.tecdo.sdk.web.Application
                     * @instance
                     */
                    Application.prototype.ee = "";

                    /**
                     * Application ef.
                     * @member {string} ef
                     * @memberof com.tecdo.sdk.web.Application
                     * @instance
                     */
                    Application.prototype.ef = "";

                    /**
                     * Application eg.
                     * @member {string} eg
                     * @memberof com.tecdo.sdk.web.Application
                     * @instance
                     */
                    Application.prototype.eg = "";

                    /**
                     * Creates a new Application instance using the specified properties.
                     * @function create
                     * @memberof com.tecdo.sdk.web.Application
                     * @static
                     * @param {com.tecdo.sdk.web.IApplication=} [properties] Properties to set
                     * @returns {com.tecdo.sdk.web.Application} Application instance
                     */
                    Application.create = function create(properties) {
                        return new Application(properties);
                    };

                    /**
                     * Encodes the specified Application message. Does not implicitly {@link com.tecdo.sdk.web.Application.verify|verify} messages.
                     * @function encode
                     * @memberof com.tecdo.sdk.web.Application
                     * @static
                     * @param {com.tecdo.sdk.web.IApplication} m Application message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Application.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.ea != null && Object.hasOwnProperty.call(m, "ea"))
                            w.uint32(10).string(m.ea);
                        if (m.eb != null && Object.hasOwnProperty.call(m, "eb"))
                            w.uint32(18).string(m.eb);
                        if (m.ec != null && Object.hasOwnProperty.call(m, "ec"))
                            w.uint32(26).string(m.ec);
                        if (m.ed != null && Object.hasOwnProperty.call(m, "ed"))
                            w.uint32(34).string(m.ed);
                        if (m.ee != null && Object.hasOwnProperty.call(m, "ee"))
                            w.uint32(42).string(m.ee);
                        if (m.ef != null && Object.hasOwnProperty.call(m, "ef"))
                            w.uint32(50).string(m.ef);
                        if (m.eg != null && Object.hasOwnProperty.call(m, "eg"))
                            w.uint32(58).string(m.eg);
                        return w;
                    };

                    /**
                     * Gets the default type url for Application
                     * @function getTypeUrl
                     * @memberof com.tecdo.sdk.web.Application
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Application.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.tecdo.sdk.web.Application";
                    };

                    return Application;
                })();

                web.Location = (function() {

                    /**
                     * Properties of a Location.
                     * @memberof com.tecdo.sdk.web
                     * @interface ILocation
                     * @property {string|null} [fa] Location fa
                     * @property {number|null} [fb] Location fb
                     */

                    /**
                     * Constructs a new Location.
                     * @memberof com.tecdo.sdk.web
                     * @classdesc Represents a Location.
                     * @implements ILocation
                     * @constructor
                     * @param {com.tecdo.sdk.web.ILocation=} [p] Properties to set
                     */
                    function Location(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * Location fa.
                     * @member {string} fa
                     * @memberof com.tecdo.sdk.web.Location
                     * @instance
                     */
                    Location.prototype.fa = "";

                    /**
                     * Location fb.
                     * @member {number} fb
                     * @memberof com.tecdo.sdk.web.Location
                     * @instance
                     */
                    Location.prototype.fb = 0;

                    /**
                     * Creates a new Location instance using the specified properties.
                     * @function create
                     * @memberof com.tecdo.sdk.web.Location
                     * @static
                     * @param {com.tecdo.sdk.web.ILocation=} [properties] Properties to set
                     * @returns {com.tecdo.sdk.web.Location} Location instance
                     */
                    Location.create = function create(properties) {
                        return new Location(properties);
                    };

                    /**
                     * Encodes the specified Location message. Does not implicitly {@link com.tecdo.sdk.web.Location.verify|verify} messages.
                     * @function encode
                     * @memberof com.tecdo.sdk.web.Location
                     * @static
                     * @param {com.tecdo.sdk.web.ILocation} m Location message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Location.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.fa != null && Object.hasOwnProperty.call(m, "fa"))
                            w.uint32(10).string(m.fa);
                        if (m.fb != null && Object.hasOwnProperty.call(m, "fb"))
                            w.uint32(16).int32(m.fb);
                        return w;
                    };

                    /**
                     * Gets the default type url for Location
                     * @function getTypeUrl
                     * @memberof com.tecdo.sdk.web.Location
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Location.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.tecdo.sdk.web.Location";
                    };

                    return Location;
                })();

                web.Security = (function() {

                    /**
                     * Properties of a Security.
                     * @memberof com.tecdo.sdk.web
                     * @interface ISecurity
                     * @property {boolean|null} [ga] Security ga
                     * @property {boolean|null} [gb] Security gb
                     * @property {boolean|null} [gc] Security gc
                     * @property {string|null} [gd] Security gd
                     * @property {string|null} [ge] Security ge
                     * @property {string|null} [gf] Security gf
                     * @property {boolean|null} [gg] Security gg
                     * @property {boolean|null} [gh] Security gh
                     * @property {boolean|null} [gi] Security gi
                     * @property {string|null} [gj] Security gj
                     * @property {string|null} [gk] Security gk
                     * @property {string|null} [gl] Security gl
                     * @property {string|null} [gm] Security gm
                     */

                    /**
                     * Constructs a new Security.
                     * @memberof com.tecdo.sdk.web
                     * @classdesc Represents a Security.
                     * @implements ISecurity
                     * @constructor
                     * @param {com.tecdo.sdk.web.ISecurity=} [p] Properties to set
                     */
                    function Security(p) {
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * Security ga.
                     * @member {boolean} ga
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.ga = false;

                    /**
                     * Security gb.
                     * @member {boolean} gb
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gb = false;

                    /**
                     * Security gc.
                     * @member {boolean} gc
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gc = false;

                    /**
                     * Security gd.
                     * @member {string} gd
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gd = "";

                    /**
                     * Security ge.
                     * @member {string} ge
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.ge = "";

                    /**
                     * Security gf.
                     * @member {string} gf
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gf = "";

                    /**
                     * Security gg.
                     * @member {boolean} gg
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gg = false;

                    /**
                     * Security gh.
                     * @member {boolean} gh
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gh = false;

                    /**
                     * Security gi.
                     * @member {boolean} gi
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gi = false;

                    /**
                     * Security gj.
                     * @member {string} gj
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gj = "";

                    /**
                     * Security gk.
                     * @member {string} gk
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gk = "";

                    /**
                     * Security gl.
                     * @member {string} gl
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gl = "";

                    /**
                     * Security gm.
                     * @member {string} gm
                     * @memberof com.tecdo.sdk.web.Security
                     * @instance
                     */
                    Security.prototype.gm = "";

                    /**
                     * Creates a new Security instance using the specified properties.
                     * @function create
                     * @memberof com.tecdo.sdk.web.Security
                     * @static
                     * @param {com.tecdo.sdk.web.ISecurity=} [properties] Properties to set
                     * @returns {com.tecdo.sdk.web.Security} Security instance
                     */
                    Security.create = function create(properties) {
                        return new Security(properties);
                    };

                    /**
                     * Encodes the specified Security message. Does not implicitly {@link com.tecdo.sdk.web.Security.verify|verify} messages.
                     * @function encode
                     * @memberof com.tecdo.sdk.web.Security
                     * @static
                     * @param {com.tecdo.sdk.web.ISecurity} m Security message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Security.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.ga != null && Object.hasOwnProperty.call(m, "ga"))
                            w.uint32(8).bool(m.ga);
                        if (m.gb != null && Object.hasOwnProperty.call(m, "gb"))
                            w.uint32(16).bool(m.gb);
                        if (m.gc != null && Object.hasOwnProperty.call(m, "gc"))
                            w.uint32(24).bool(m.gc);
                        if (m.gd != null && Object.hasOwnProperty.call(m, "gd"))
                            w.uint32(34).string(m.gd);
                        if (m.ge != null && Object.hasOwnProperty.call(m, "ge"))
                            w.uint32(42).string(m.ge);
                        if (m.gf != null && Object.hasOwnProperty.call(m, "gf"))
                            w.uint32(50).string(m.gf);
                        if (m.gg != null && Object.hasOwnProperty.call(m, "gg"))
                            w.uint32(56).bool(m.gg);
                        if (m.gh != null && Object.hasOwnProperty.call(m, "gh"))
                            w.uint32(64).bool(m.gh);
                        if (m.gi != null && Object.hasOwnProperty.call(m, "gi"))
                            w.uint32(72).bool(m.gi);
                        if (m.gj != null && Object.hasOwnProperty.call(m, "gj"))
                            w.uint32(82).string(m.gj);
                        if (m.gk != null && Object.hasOwnProperty.call(m, "gk"))
                            w.uint32(90).string(m.gk);
                        if (m.gl != null && Object.hasOwnProperty.call(m, "gl"))
                            w.uint32(98).string(m.gl);
                        if (m.gm != null && Object.hasOwnProperty.call(m, "gm"))
                            w.uint32(106).string(m.gm);
                        return w;
                    };

                    /**
                     * Gets the default type url for Security
                     * @function getTypeUrl
                     * @memberof com.tecdo.sdk.web.Security
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    Security.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.tecdo.sdk.web.Security";
                    };

                    return Security;
                })();

                return web;
            })();

            return sdk;
        })();

        return tecdo;
    })();

    com.ssp = (function() {

        /**
         * Namespace ssp.
         * @memberof com
         * @namespace
         */
        const ssp = {};

        ssp.sdk = (function() {

            /**
             * Namespace sdk.
             * @memberof com.ssp
             * @namespace
             */
            const sdk = {};

            sdk.event = (function() {

                /**
                 * Namespace event.
                 * @memberof com.ssp.sdk
                 * @namespace
                 */
                const event = {};

                event.BaseEventData = (function() {

                    /**
                     * Properties of a BaseEventData.
                     * @memberof com.ssp.sdk.event
                     * @interface IBaseEventData
                     * @property {string|null} [sessionId] BaseEventData sessionId
                     * @property {string|null} [preSessionId] BaseEventData preSessionId
                     * @property {string|null} [requestId] BaseEventData requestId
                     * @property {string|null} [preRequestId] BaseEventData preRequestId
                     * @property {number|Long|null} [timestamp] BaseEventData timestamp
                     * @property {string|null} [appId] BaseEventData appId
                     * @property {string|null} [appVersion] BaseEventData appVersion
                     * @property {string|null} [sdkVersion] BaseEventData sdkVersion
                     * @property {string|null} [bizType] BaseEventData bizType
                     * @property {string|null} [platform] BaseEventData platform
                     * @property {string|null} [dataVersion] BaseEventData dataVersion
                     * @property {string|null} [deviceId] BaseEventData deviceId
                     * @property {Array.<com.ssp.sdk.event.IEventData>|null} [events] BaseEventData events
                     * @property {string|null} [clientIp] BaseEventData clientIp
                     * @property {string|null} [countryCode] BaseEventData countryCode
                     */

                    /**
                     * Constructs a new BaseEventData.
                     * @memberof com.ssp.sdk.event
                     * @classdesc Represents a BaseEventData.
                     * @implements IBaseEventData
                     * @constructor
                     * @param {com.ssp.sdk.event.IBaseEventData=} [p] Properties to set
                     */
                    function BaseEventData(p) {
                        this.events = [];
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * BaseEventData sessionId.
                     * @member {string} sessionId
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.sessionId = "";

                    /**
                     * BaseEventData preSessionId.
                     * @member {string} preSessionId
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.preSessionId = "";

                    /**
                     * BaseEventData requestId.
                     * @member {string} requestId
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.requestId = "";

                    /**
                     * BaseEventData preRequestId.
                     * @member {string} preRequestId
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.preRequestId = "";

                    /**
                     * BaseEventData timestamp.
                     * @member {number|Long} timestamp
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * BaseEventData appId.
                     * @member {string} appId
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.appId = "";

                    /**
                     * BaseEventData appVersion.
                     * @member {string} appVersion
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.appVersion = "";

                    /**
                     * BaseEventData sdkVersion.
                     * @member {string} sdkVersion
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.sdkVersion = "";

                    /**
                     * BaseEventData bizType.
                     * @member {string} bizType
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.bizType = "";

                    /**
                     * BaseEventData platform.
                     * @member {string} platform
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.platform = "";

                    /**
                     * BaseEventData dataVersion.
                     * @member {string} dataVersion
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.dataVersion = "";

                    /**
                     * BaseEventData deviceId.
                     * @member {string} deviceId
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.deviceId = "";

                    /**
                     * BaseEventData events.
                     * @member {Array.<com.ssp.sdk.event.IEventData>} events
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.events = $util.emptyArray;

                    /**
                     * BaseEventData clientIp.
                     * @member {string} clientIp
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.clientIp = "";

                    /**
                     * BaseEventData countryCode.
                     * @member {string} countryCode
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @instance
                     */
                    BaseEventData.prototype.countryCode = "";

                    /**
                     * Creates a new BaseEventData instance using the specified properties.
                     * @function create
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @static
                     * @param {com.ssp.sdk.event.IBaseEventData=} [properties] Properties to set
                     * @returns {com.ssp.sdk.event.BaseEventData} BaseEventData instance
                     */
                    BaseEventData.create = function create(properties) {
                        return new BaseEventData(properties);
                    };

                    /**
                     * Encodes the specified BaseEventData message. Does not implicitly {@link com.ssp.sdk.event.BaseEventData.verify|verify} messages.
                     * @function encode
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @static
                     * @param {com.ssp.sdk.event.IBaseEventData} m BaseEventData message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BaseEventData.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.sessionId != null && Object.hasOwnProperty.call(m, "sessionId"))
                            w.uint32(10).string(m.sessionId);
                        if (m.preSessionId != null && Object.hasOwnProperty.call(m, "preSessionId"))
                            w.uint32(18).string(m.preSessionId);
                        if (m.requestId != null && Object.hasOwnProperty.call(m, "requestId"))
                            w.uint32(26).string(m.requestId);
                        if (m.preRequestId != null && Object.hasOwnProperty.call(m, "preRequestId"))
                            w.uint32(34).string(m.preRequestId);
                        if (m.timestamp != null && Object.hasOwnProperty.call(m, "timestamp"))
                            w.uint32(40).int64(m.timestamp);
                        if (m.appId != null && Object.hasOwnProperty.call(m, "appId"))
                            w.uint32(50).string(m.appId);
                        if (m.appVersion != null && Object.hasOwnProperty.call(m, "appVersion"))
                            w.uint32(58).string(m.appVersion);
                        if (m.sdkVersion != null && Object.hasOwnProperty.call(m, "sdkVersion"))
                            w.uint32(66).string(m.sdkVersion);
                        if (m.bizType != null && Object.hasOwnProperty.call(m, "bizType"))
                            w.uint32(74).string(m.bizType);
                        if (m.platform != null && Object.hasOwnProperty.call(m, "platform"))
                            w.uint32(82).string(m.platform);
                        if (m.dataVersion != null && Object.hasOwnProperty.call(m, "dataVersion"))
                            w.uint32(90).string(m.dataVersion);
                        if (m.deviceId != null && Object.hasOwnProperty.call(m, "deviceId"))
                            w.uint32(98).string(m.deviceId);
                        if (m.events != null && m.events.length) {
                            for (var i = 0; i < m.events.length; ++i)
                                $root.com.ssp.sdk.event.EventData.encode(m.events[i], w.uint32(106).fork()).ldelim();
                        }
                        if (m.clientIp != null && Object.hasOwnProperty.call(m, "clientIp"))
                            w.uint32(114).string(m.clientIp);
                        if (m.countryCode != null && Object.hasOwnProperty.call(m, "countryCode"))
                            w.uint32(122).string(m.countryCode);
                        return w;
                    };

                    /**
                     * Gets the default type url for BaseEventData
                     * @function getTypeUrl
                     * @memberof com.ssp.sdk.event.BaseEventData
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BaseEventData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.ssp.sdk.event.BaseEventData";
                    };

                    return BaseEventData;
                })();

                event.EventData = (function() {

                    /**
                     * Properties of an EventData.
                     * @memberof com.ssp.sdk.event
                     * @interface IEventData
                     * @property {string|null} [eventId] EventData eventId
                     * @property {string|null} [preEventId] EventData preEventId
                     * @property {string|null} [eventName] EventData eventName
                     * @property {string|null} [eventType] EventData eventType
                     * @property {number|Long|null} [timestamp] EventData timestamp
                     * @property {Object.<string,string>|null} [eventParams] EventData eventParams
                     * @property {Object.<string,string>|null} [attribution] EventData attribution
                     */

                    /**
                     * Constructs a new EventData.
                     * @memberof com.ssp.sdk.event
                     * @classdesc Represents an EventData.
                     * @implements IEventData
                     * @constructor
                     * @param {com.ssp.sdk.event.IEventData=} [p] Properties to set
                     */
                    function EventData(p) {
                        this.eventParams = {};
                        this.attribution = {};
                        if (p)
                            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                                if (p[ks[i]] != null)
                                    this[ks[i]] = p[ks[i]];
                    }

                    /**
                     * EventData eventId.
                     * @member {string} eventId
                     * @memberof com.ssp.sdk.event.EventData
                     * @instance
                     */
                    EventData.prototype.eventId = "";

                    /**
                     * EventData preEventId.
                     * @member {string} preEventId
                     * @memberof com.ssp.sdk.event.EventData
                     * @instance
                     */
                    EventData.prototype.preEventId = "";

                    /**
                     * EventData eventName.
                     * @member {string} eventName
                     * @memberof com.ssp.sdk.event.EventData
                     * @instance
                     */
                    EventData.prototype.eventName = "";

                    /**
                     * EventData eventType.
                     * @member {string} eventType
                     * @memberof com.ssp.sdk.event.EventData
                     * @instance
                     */
                    EventData.prototype.eventType = "";

                    /**
                     * EventData timestamp.
                     * @member {number|Long} timestamp
                     * @memberof com.ssp.sdk.event.EventData
                     * @instance
                     */
                    EventData.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * EventData eventParams.
                     * @member {Object.<string,string>} eventParams
                     * @memberof com.ssp.sdk.event.EventData
                     * @instance
                     */
                    EventData.prototype.eventParams = $util.emptyObject;

                    /**
                     * EventData attribution.
                     * @member {Object.<string,string>} attribution
                     * @memberof com.ssp.sdk.event.EventData
                     * @instance
                     */
                    EventData.prototype.attribution = $util.emptyObject;

                    /**
                     * Creates a new EventData instance using the specified properties.
                     * @function create
                     * @memberof com.ssp.sdk.event.EventData
                     * @static
                     * @param {com.ssp.sdk.event.IEventData=} [properties] Properties to set
                     * @returns {com.ssp.sdk.event.EventData} EventData instance
                     */
                    EventData.create = function create(properties) {
                        return new EventData(properties);
                    };

                    /**
                     * Encodes the specified EventData message. Does not implicitly {@link com.ssp.sdk.event.EventData.verify|verify} messages.
                     * @function encode
                     * @memberof com.ssp.sdk.event.EventData
                     * @static
                     * @param {com.ssp.sdk.event.IEventData} m EventData message or plain object to encode
                     * @param {$protobuf.Writer} [w] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EventData.encode = function encode(m, w) {
                        if (!w)
                            w = $Writer.create();
                        if (m.eventId != null && Object.hasOwnProperty.call(m, "eventId"))
                            w.uint32(10).string(m.eventId);
                        if (m.preEventId != null && Object.hasOwnProperty.call(m, "preEventId"))
                            w.uint32(18).string(m.preEventId);
                        if (m.eventName != null && Object.hasOwnProperty.call(m, "eventName"))
                            w.uint32(26).string(m.eventName);
                        if (m.eventType != null && Object.hasOwnProperty.call(m, "eventType"))
                            w.uint32(34).string(m.eventType);
                        if (m.timestamp != null && Object.hasOwnProperty.call(m, "timestamp"))
                            w.uint32(40).int64(m.timestamp);
                        if (m.eventParams != null && Object.hasOwnProperty.call(m, "eventParams")) {
                            for (var ks = Object.keys(m.eventParams), i = 0; i < ks.length; ++i) {
                                w.uint32(50).fork().uint32(10).string(ks[i]).uint32(18).string(m.eventParams[ks[i]]).ldelim();
                            }
                        }
                        if (m.attribution != null && Object.hasOwnProperty.call(m, "attribution")) {
                            for (var ks = Object.keys(m.attribution), i = 0; i < ks.length; ++i) {
                                w.uint32(58).fork().uint32(10).string(ks[i]).uint32(18).string(m.attribution[ks[i]]).ldelim();
                            }
                        }
                        return w;
                    };

                    /**
                     * Gets the default type url for EventData
                     * @function getTypeUrl
                     * @memberof com.ssp.sdk.event.EventData
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    EventData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.ssp.sdk.event.EventData";
                    };

                    return EventData;
                })();

                return event;
            })();

            return sdk;
        })();

        return ssp;
    })();

    return com;
})();

export { $root as default };
